import React from "react";

export default function BarcodeLabelField({ record }) {
  return (
    <a href={record.barcodeLabel} target="_blank" rel="noopener noreferrer">
      pdf
    </a>
  );
}
